import { GlobalDocuments } from '.';

export interface Legaldocuments {
    scb?: GlobalDocuments;
    svg?: GlobalDocuments;
    vfsc?: GlobalDocuments;
}
